module.exports = __webpack_public_path__ + "img/6-4.2d69f4e4.jpg";